module.exports = __webpack_public_path__ + "0b2b58e89cd87eaca25ab670fc393125.svg";